<template lang="pug">
#hiring(:class="$router.currentRoute.name")
  cp-header(:partner="hasPartnerA2G")

  .hiring-step.pass-step
    div
      h1.hiring-step__title Quem vai viajar?
      p.hiring-step__subtitle Passageiro deve ser domiciliado ou residente legal no Brasil.
      cp-passenger-form(
        v-for="(passenger, index) in listPassengers"
        ref="passenger"
        :index="index"
        :passenger="passenger"
        :passengers="listPassengers"
        :lead="lead"
        :key="index"
        @change="setPassenger($event, index)"
      )

      button.btn.btn-next(
          @click="nextStep",
          :disabled="!editVoucher",
          :tracking="tracking()"
        ) continuar para o pagamento

  cb-footer(
    v-if="!hasPartnerA2G",
    product="trip",
    :hideLinks="showLivelo ? [] : ['pontos-livelo']"
    INSTITUCIONAL_URL="https://www.ciclic.com.br"
  )
</template>

<script>
import { required, helpers, email, minLength, maxLength } from 'vuelidate/lib/validators'
import { mapMutations, mapState, mapGetters } from 'vuex'
import moment from 'moment'

import views from '@/mixins/views'

import cpHeader from '@/components/ui/Header.vue'
import cpPassengerForm from '@/components/PassengerForm.vue'
import CpField from '@/components/views/Field.vue'
import CpCheckbox from '@/components/ui/Checkbox.vue'

import { checkout } from '@/utils/checkout'

export default {
  name: 'view-passengers',
  mixins: [views],
  data () {
    return {
      listPassengers: [],
      validationDateBirthPassenger: true,
      editVoucher: false,
      hasInfoFromLead: false
    }
  },
  components: {
    cpHeader,
    cpPassengerForm,
    CpField,
    CpCheckbox
  },
  mounted () {
    if (this.$store.state.user.passengers.length > 0) {
      this.$store.state.user.passengers.map((item) => {
        item.dateOfBirthDisplay = moment(item.dateOfBirth, 'YYYY-MM-DD').format(
          'DDMMYYYY'
        )
        this.listPassengers.push(item)
      })
    } else {
      if (this.numberOfPassengersFourtyYears > 0) {
        for (let i = 0; i < this.numberOfPassengersFourtyYears; i++) {
          const passenger = {
            name: null,
            cpf: null,
            cpfLegalResponsible: null,
            nameLegalResponsible: null,
            dateOfBirth: null,
            lblAgeRange: '0 a 40',
            confirmation: false,
            isUnderThen18: false,
            isUnderThen40: true,
            gender: null,
            phone: null,
            activated: false
          }
          this.listPassengers.push(passenger)
        }
      }

      if (this.numberOfPassengersSixtyFourYears > 0) {
        for (let i = 0; i < this.numberOfPassengersSixtyFourYears; i++) {
          const passenger = {
            name: null,
            cpf: null,
            cpfLegalResponsible: null,
            nameLegalResponsible: null,
            dateOfBirth: null,
            lblAgeRange: '41 a 64',
            confirmation: false,
            isUnderThen64: true,
            gender: null,
            phone: null,
            activated: false
          }
          this.listPassengers.push(passenger)
        }
      }

      if (this.numberOfPassengersSeventyFiveYears > 0) {
        for (let i = 0; i < this.numberOfPassengersSeventyFiveYears; i++) {
          const passenger = {
            name: null,
            cpf: null,
            cpfLegalResponsible: null,
            nameLegalResponsible: null,
            dateOfBirth: null,
            lblAgeRange: '65 a 75',
            confirmation: false,
            isUnderThen75: true,
            gender: null,
            phone: null,
            activated: false
          }
          this.listPassengers.push(passenger)
        }
      }

      if (this.numberOfPassengersEightyFiveYears > 0) {
        for (let i = 0; i < this.numberOfPassengersEightyFiveYears; i++) {
          const passenger = {
            name: null,
            cpf: null,
            cpfLegalResponsible: null,
            nameLegalResponsible: null,
            dateOfBirth: null,
            lblAgeRange: '76 a 85',
            confirmation: false,
            isUnderThen85: true,
            gender: null,
            phone: null,
            activated: false
          }
          this.listPassengers.push(passenger)
        }
      }
      if (this.numberOfPassengersNinetyNineYears > 0) {
        for (let i = 0; i < this.numberOfPassengersNinetyNineYears; i++) {
          const passenger = {
            name: null,
            cpf: null,
            cpfLegalResponsible: null,
            nameLegalResponsible: null,
            dateOfBirth: null,
            lblAgeRange: '86 a 99',
            confirmation: false,
            isUnderThen99: true,
            gender: null,
            phone: null,
            activated: false
          }
          this.listPassengers.push(passenger)
        }
      }
    }

    this.listPassengers[0].activated = true

    const productStore = sessionStorage.getItem('ciclic:product')

    if (!this.lead.leadName && productStore) {
      const { personalData: { cellphone, email, name } } = JSON.parse(productStore)

      this.lead.leadEmail = email
      this.lead.leadName = name
      this.lead.leadPhone = cellphone.replace(/(\d\d)/, '($1)')
    }
  },
  computed: {
    ...mapState('travelSetup', ['theme', 'lead']),
    ...mapState('user', ['invalidPassenger', 'passenger', 'passengers']),
    ...mapState('quotation', [
      'numberOfPassengersFourtyYears',
      'numberOfPassengersSixtyFourYears',
      'numberOfPassengersSeventyFiveYears',
      'numberOfPassengersEightyFiveYears',
      'numberOfPassengersNinetyNineYears'
    ]),
    ...mapGetters('quotation', ['showLivelo']),
    hasPartnerA2G () {
      return this.theme === 'a2g'
    },
    disableBtn () {
      const invalidPassenger =
        this.validationDateBirthPassenger || this.$v.$invalid
      this.setInvalidPassenger(invalidPassenger)
      return invalidPassenger
    },
    name () {
      return this.$store.state.user.voucherRecipient.name
    },
    email () {
      return this.$store.state.user.voucherRecipient.email
    },
    nameValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Por favor, informe seu nome completo',
          valid: false
        },
        {
          type: 'error',
          msg: 'Por favor, informe seu nome',
          valid: false
        },
        {
          type: 'error',
          msg: 'Limite de 30 caracteres',
          valid: false
        }
      ]

      if (!this.$v.name.$invalid) return { valid: true }
      if (!this.$v.name.blackListName) return validations[1]
      if (!this.$v.name.maxLength) return validations[2]
      if (this.$v.name.$dirty && this.$v.name.$invalid) return validations[0]

      return {}
    },
    emailValidation () {
      let validations = [
        {
          type: 'error',
          msg: 'Por favor, insira um e-mail.',
          valid: false
        },
        {
          type: 'error',
          msg: 'Por favor, insira um e-mail válido.',
          valid: false
        },
        {
          type: 'error',
          msg: 'Limite de 100 caracteres',
          valid: false
        }
      ]
      if (!this.$v.email.$invalid) {
        return { valid: true }
      }
      if (this.$v.email.$dirty && !this.$v.email.required) {
        return validations[0]
      }
      if (!this.$v.email.maxLength) {
        return validations[2]
      }
      if ((this.$v.email.$dirty && this.$v.email.$invalid) || !this.$v.email.email) {
        return validations[1]
      }

      return {}
    }
  },
  methods: {
    ...mapMutations('user', [
      'changeInvalidPassenger',
      'changeListPassengers',
      'changeVoucherRecipientName',
      'changeVoucherRecipientEmail'
    ]),
    async nextStep () {
      await this.changeListPassengers(this.listPassengers)

      checkout(this)

      window.sessionStorage.removeItem('ciclic:checkout')
      window.location.replace(`${process.env.VUE_APP_HOME_URL}checkout/#/dados-pessoais`)
    },
    setPassenger (value, i) {
      this.listPassengers[i] = value

      // when confirmed, next passenger is released to fill
      this.$refs.passenger &&
      this.$refs.passenger.map((attr) => {
        if (attr.confirmation) {
          const nextPassengerId = attr.index + 1

          if (this.listPassengers.length > nextPassengerId) {
            this.$refs.passenger[nextPassengerId].activated = true
          } else {
            this.editVoucher = true
          }
        }
      })

      // If has a one value as true, disable button
      this.validationDateBirthPassenger =
        this.$refs.passenger &&
        !this.$refs.passenger
          .map((attr) => attr.validation && attr.confirmation)
          .reduce((a, c) => a && c)

      if (this.validationDateBirthPassenger) {
        this.editVoucher = false
      }
    },
    setName (value) {
      this.changeVoucherRecipientName(value)
      this.setDirty(this.$v.name)
    },
    setEmail (value) {
      this.changeVoucherRecipientEmail(value.toLowerCase().trim())
      this.setDirty(this.$v.email)
    },
    setInfoFromPassengers (checked) {
      if (checked) {
        this.setName(this.lead.leadName)
        this.setEmail(this.lead.leadEmail)
        this.hasInfoFromLead = true
      } else {
        this.setName('')
        this.setEmail('')
        this.hasInfoFromLead = false
      }
    },
    setInvalidPassenger (value) {
      this.changeInvalidPassenger(value)
    },
    tracking () {
      return `{ "category": "Contratação", "action": "0.8.Passageiros", "label": "Passageiros", "value": null }`
    }
  },
  updated () {
    const passengerName = document.querySelector('#passengerName1')
    if (passengerName && !passengerName.value) {
      passengerName.focus()
    }
  },
  validations: {
    name: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(30),
      alphaWhiteDiacritic: helpers.regex(
        'alphaWhiteDiacritic',
        /^[a-zA-ZÀ-ž.\s]*$/
      ),
      nameWithoutBeingBlank: helpers.regex(
        'nameWithoutBeingBlank',
        /^([a-zá-úA-ZÁ-Ú]{2,})/
      ),
      blackListName: (value) =>
        !/((^|\s)((teste|test)(s)?)(\s|$))/i.test(value)
    },
    email: {
      required,
      maxLength: maxLength(100),
      validateEmail: helpers.regex(
        'validateEmail',
        /^[a-z0-9._-]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/
      ),
      blackListEmail: (value) =>
        ['teste@teste.com', 'teste@teste.com.br'].indexOf(value) === -1,
      email
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/ui/variables";

.captalize {
  text-transform: capitalize;
}

#hiring {
  background-color: #ebf0f5;
  color: #2c3e50;
  box-sizing: border-box;
  min-height: 100vh;
  width: 100%;

  &.confirmation {
    @media screen and (max-width: 767px) {
      background-color: $white;
      padding-bottom: 0;
    }
  }

  @media screen and (max-width: 767px) {
    ::-webkit-scrollbar {
      display: none;
    }
  }
}

// Passo do fluxo de cadastro em flex.
.hiring-step {
  display: flex;
  flex-flow: column;
  max-width: 547px;
  margin: 0 auto;
  min-height: calc(100vh - 57px);
  width: 100%;

  @media screen and (min-width: 426px) {
    padding-bottom: 150px;
    min-height: calc(100vh - 88px);
  }

  .header ~ & {
    min-height: calc(100vh - 112px);

    @media screen and (min-width: 426px) {
      min-height: calc(100vh - 164px);
    }
  }

  h1.hiring-step__title {
    font-size: 20px;
    font-weight: bold;
    margin: 20px 24px 0 32px;
    color: #444444;
    font-family: $oscine-font-family;

    @media screen and (min-width: 768px) {
      font-size: 32px;
      text-align: center;
    }
  }

  &.confirmation {
    max-width: 920px;

    @media screen and (max-width: 767px) {
      box-shadow: none;
    }
  }

  // Título para o cadastro com o gradient na frase após a vírgula.
  h1 {
    font-size: 28px;
    line-height: 42px;
    color: rgba(50, 75, 104, 1);
    user-select: none;

    // white-space: nowrap;
    @media screen and (max-width: 767px) {
      font-size: 24px;
      font-weight: bold;
      color: $base-color;
      line-height: 28px;
    }

    span {
      background: linear-gradient(45deg, #d5fc57, #12e3c3);
      border-radius: 10px;
      display: inline-block;
      height: 15px;
      line-height: 13px;
    }
  }

  .msg-error {
    background-image: linear-gradient(-270deg, #fe52b4 0%, #fffe92 100%);
    position: fixed;
    width: 100%;
    height: auto;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    z-index: 10;

    span {
      text-align: center;
      font-weight: 500;
      font-size: 16px;
      font-family: $rubik-font-family;
      color: $base-color;
      padding: 16px;

      @media screen and (max-width: 767px) {
        font-size: 14px;
      }
    }

    @at-root {
      .header ~ .hiring-step .msg-error {
        top: 76px;

        @media screen and (max-width: 767px) {
          top: 56px;
        }
      }
    }
  }
}

.loader-content {
  align-items: center;
  background-color: rgba($white, 0.95);
  display: flex;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  left: 0;
  position: fixed;
  top: 0;
  z-index: 20;
}

.passengers-data .btn-next {
  margin-top: auto;
}

.emailPassenger {
  width: 100%;
  max-width: 600px;
  height: 477px;
  padding: 40px 32px;

  @media screen and (max-width: 768px) {
    padding: 20px 24px;
  }

  &__title {
    font-size: 24px;
    font-family: $oscine-font-family;
    color: #444444;
    font-weight: bold;

    @media screen and (max-width: 768px) {
      font-size: 18px;
    }
  }

  &__subtitle {
    font-size: 16px;
    font-family: $rubik-font-family;
    color: #595959;
    line-height: 1.38;
    font-weight: normal;

    @media screen and (max-width: 768px) {
      font-size: 14px;
    }
  }

  &__disabled {
    height: 80px;
    display: flex;
    align-items: center;

    &__title {
      font-size: 18px;
      font-family: $oscine-font-family;
      color: #8e8e93;
      font-weight: bold;
      position: relative;
      padding-left: 30px;

      &::before {
        width: 40px;
        height: 40px;
        content: "";
        position: absolute;
        left: -20px;
        top: -8px;
        background: url("~@/assets/icons/voucher.svg") no-repeat center top;
      }
    }
  }

  .field {
    padding: 0;
    margin-top: 24px;

    .input {
      margin: 0;
    }
  }
}

.hiring-step__subtitle {
  margin-bottom: 40px;
  margin-left: 32px;
  font-size: 14px;
  text-align: left;
  color: #595959;
  font-family: $rubik-font-family;

  @media screen and (min-width: 768px) {
    text-align: center;
    font-size: 16px;
  }
}

.btn {
  background-color: #6320e9;
  height: 48px;
  width: 100%;
  max-width: 536px;
  margin-top: 40px;
  border-radius: 30px;
  font-size: 16px;
}
</style>
